import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProvinceResponse, HousingResponse, ZoneListResponse, GetZoneRequest, GetHousingRequest, ProvinceSearchRequest } from '../models';

interface ZoneState {
  provinceList: ProvinceResponse[];
  housingList: HousingResponse[];
  zoneList: ZoneListResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: ZoneState = {
  provinceList: [],
  housingList: [],
  zoneList: null,
  loading: false,
  error: null,
};

const zoneSlice = createSlice({
  name: 'zone',
  initialState,
  reducers: {
    fetchProvinceListStart: (state, action: PayloadAction<ProvinceSearchRequest>) => {
      state.loading = true;
      state.error = null;
    },
    fetchProvinceListSuccess: (state, action: PayloadAction<ProvinceResponse[]>) => {
      state.loading = false;
      state.provinceList = action.payload;
      state.error = null;
    },
    fetchProvinceListFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearProvinceList: (state) => {
      state.provinceList = [];
      state.error = null;
    },
    fetchHousingListStart: (state, action: PayloadAction<GetHousingRequest>) => {
      state.loading = true;
      state.error = null;
    },
    fetchHousingListSuccess: (state, action: PayloadAction<HousingResponse[]>) => {
      state.loading = false;
      state.housingList = action.payload;
      state.error = null;
    },
    fetchHousingListFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearHousingList: (state) => {
      state.housingList = [];
      state.error = null;
    },
    fetchZoneListStart: (state, action: PayloadAction<GetZoneRequest>) => {
      state.loading = true;
      state.error = null;
    },
    fetchZoneListSuccess: (state, action: PayloadAction<ZoneListResponse>) => {
      state.loading = false;
      state.zoneList = action.payload;
      state.error = null;
    },
    fetchZoneListFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearZoneList: (state) => {
      state.zoneList = null;
      state.error = null;
    },
  },
});

export const zoneActions = zoneSlice.actions;
export const zoneReducer = zoneSlice.reducer;

// Selectors
export const selectProvinceList = (state: any) => state.zone.provinceList;
export const selectLoadingProvince = (state: any) => state.zone.loading;
export const selectProvinceError = (state: any) => state.zone.error;
export const selectHousingList = (state: any) => state.zone.housingList;
export const selectLoadingHousing = (state: any) => state.zone.loading;
export const selectHousingError = (state: any) => state.zone.error;
export const selectZoneList = (state: any) => state.zone.zoneList;
export const selectLoadingZone = (state: any) => state.zone.loading;
export const selectZoneError = (state: any) => state.zone.error;

